// THIS FILE IS GENERATED, DO NOT EDIT!
/* eslint-disable */
import * as Types from '@h5s/dtos-api';

import { LocalDate, LocalDateTime, LocalTime } from '@h5s/util-date';
import { gql } from 'apollo-angular';
export type IstatTypeFragment = { __typename?: 'IstatTypeDTO', beds: boolean, countryCode: string, daily: boolean, fromTo: boolean, id: number, istatCode: boolean, istatPassword: boolean, istatUrl: boolean, istatUser: boolean, monthly: boolean, needSearch: boolean, openingDays: boolean, paidCasualWorkers: boolean, paidRegularWorkers: boolean, printable: boolean, rooms: boolean, sendFacilityClosure: boolean, sendFile: boolean, sendIstatClosure: boolean, sendOnline: boolean, toilets: boolean, type: Types.IstatTypeEnum, unpaidWorkers: boolean, cityTax: boolean };

export const IstatTypeFragment = gql`
    fragment IstatType on IstatTypeDTO {
  beds
  countryCode
  daily
  fromTo
  id
  istatCode
  istatPassword
  istatUrl
  istatUser
  monthly
  needSearch
  openingDays
  paidCasualWorkers
  paidRegularWorkers
  printable
  rooms
  sendFacilityClosure
  sendFile
  sendIstatClosure
  sendOnline
  toilets
  type
  unpaidWorkers
  type
  cityTax
}
    `;
/* eslint-enable */